// extracted by mini-css-extract-plugin
export default {"tupacGrid":"cl-z","tupacHeader":"dl-z","tupacHeader2":"el-z","tupacMenu":"fl-z","tupacMenu2":"gl-z","tupacMain":"hl-z","tupacMain2":"il-z"};